module.exports = __webpack_public_path__ + "static/media/help.17cd3edb.png";